var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section order-detail" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "left",
            disabled: _vm.isLook,
            "show-message": false
          }
        },
        [
          _c(
            "el-collapse",
            { attrs: { value: _vm.collapse } },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "订单信息", name: 1 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "订单号",
                                required: "",
                                prop: "poNo"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.poNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "poNo", $$v)
                                  },
                                  expression: "form.poNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "起运港",
                                prop: "loadingPortCode"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.form.loadingPortCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.loadingPortCode = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "目的港",
                                prop: "destinationPortCode"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.form.destinationPortCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.destinationPortCode =
                                      p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "客户",
                                required: "",
                                prop: "customerId"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "init-notify": "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  filterable: "",
                                  "default-value": _vm.form.customerId || "",
                                  "tag-name": "chineseName",
                                  "method-params": { customer: true }
                                },
                                on: { parentCallBack: _vm.customerChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "供应商", prop: "supplierId" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  filterable: "",
                                  "default-value": _vm.form.supplierId || "",
                                  "tag-name": "chineseName",
                                  "method-params": { tradersSign: true }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.supplierId = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "PO创建时间",
                                prop: "poCreationDate"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.poCreationDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "poCreationDate", $$v)
                                  },
                                  expression: "form.poCreationDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Order.Shipper") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    shipper: true,
                                    active: true
                                  },
                                  filterable: "",
                                  "default-value": _vm.form.shipper || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.shipper = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Order.RelatedParty") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    factorySign: true,
                                    active: true
                                  },
                                  filterable: "",
                                  "default-value": _vm.form.relatedParty || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.relatedParty = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Order.EntrustingDate") }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.entrustingDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "entrustingDate", $$v)
                                  },
                                  expression: "form.entrustingDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Order.Consignee") } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    consignee: true,
                                    active: true
                                  },
                                  filterable: "",
                                  "default-value": _vm.form.consignee || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.consignee = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8, offset: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单渠道", prop: "source" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.source,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "source", $$v)
                                  },
                                  expression: "form.source"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "收货地址",
                                prop: "deliveryAddress"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.deliveryAddress,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "deliveryAddress", $$v)
                                  },
                                  expression: "form.deliveryAddress"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注", prop: "remarks" } },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.form.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "remarks", $$v)
                                  },
                                  expression: "form.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "箱货信息", name: 4 } },
                [
                  _c("booking-sea-eq-data-grid", {
                    ref: "orderSeaEqDataGrid",
                    attrs: {
                      value: _vm.form.seaEQ,
                      "container-load-type": "FCL",
                      "is-edit": !_vm.isLook,
                      job: _vm.form
                    }
                  }),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "60%" },
                      attrs: { label: "注意事项" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { "min-height": "80px" },
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.form.matters,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "matters", $$v)
                          },
                          expression: "form.matters"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "货物跟踪", name: 2 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "要求货好时间",
                                prop: "requestedIncomeDate"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.requestedIncomeDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "requestedIncomeDate",
                                      $$v
                                    )
                                  },
                                  expression: "form.requestedIncomeDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "预计货好时间",
                                prop: "estimatedIncomeDate"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: "",
                                  type: "date",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.estimatedIncomeDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "estimatedIncomeDate",
                                      $$v
                                    )
                                  },
                                  expression: "form.estimatedIncomeDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "进仓状态",
                                prop: "warehouseInState"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.warehouseInState,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "warehouseInState",
                                        $$v
                                      )
                                    },
                                    expression: "form.warehouseInState"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { value: -1, label: "进仓异常" }
                                  }),
                                  _c("el-option", {
                                    attrs: { value: 0, label: "未进仓" }
                                  }),
                                  _c("el-option", {
                                    attrs: { value: 1, label: "部分进仓" }
                                  }),
                                  _c("el-option", {
                                    attrs: { value: 2, label: "全部进仓" }
                                  }),
                                  _c("el-option", {
                                    attrs: { value: 3, label: "None-无" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "延迟交货原因",
                                prop: "incomeDelayReason"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.form.incomeDelayReason,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "incomeDelayReason", $$v)
                                  },
                                  expression: "form.incomeDelayReason"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "装箱完成日期",
                                prop: "loadingDate"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  clearable: "",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.loadingDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "loadingDate", $$v)
                                  },
                                  expression: "form.loadingDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "预计离港时间", prop: "etd" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.etd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "etd", $$v)
                                  },
                                  expression: "form.etd"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "要求送达时间",
                                prop: "requestedDeliveryDate"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.requestedDeliveryDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "requestedDeliveryDate",
                                      $$v
                                    )
                                  },
                                  expression: "form.requestedDeliveryDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "预计送达时间",
                                prop: "estimatedDeliveryDate"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "date", clearable: "" },
                                model: {
                                  value: _vm.form.estimatedDeliveryDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "estimatedDeliveryDate",
                                      $$v
                                    )
                                  },
                                  expression: "form.estimatedDeliveryDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "离港延误原因",
                                prop: "departureDelayReason"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.form.departureDelayReason,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "departureDelayReason",
                                      $$v
                                    )
                                  },
                                  expression: "form.departureDelayReason"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "商品信息", name: 3 } },
                [
                  _c("goods-info", {
                    ref: "goodsInfo",
                    attrs: {
                      "order-uuid": _vm.orderUuid,
                      "po-no": _vm.orderInfo ? _vm.orderInfo.poNo : "",
                      "po-state": _vm.orderInfo ? _vm.orderInfo.state : null,
                      "order-edit-type": _vm.oprationType
                    },
                    on: { goodsSave: _vm.goodsSave }
                  })
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "包装信息", name: 4 } },
                [
                  _c("package-info", {
                    ref: "packageInfo",
                    attrs: {
                      "order-uuid": _vm.orderUuid,
                      "po-no": _vm.orderInfo ? _vm.orderInfo.poNo : "",
                      "po-state": _vm.orderInfo ? _vm.orderInfo.state : null,
                      "customer-id": _vm.orderInfo
                        ? _vm.orderInfo.customerId
                        : null,
                      "order-edit-type": _vm.oprationType
                    }
                  })
                ],
                1
              ),
              _c(
                "el-collapse-item",
                { attrs: { title: "操作信息", name: 5 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "销售公司",
                                required: "",
                                prop: "salesOffice"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Office,
                                  "init-notify": "",
                                  filterable: "",
                                  "default-value": _vm.form.salesOffice,
                                  "tag-name": "chineseName"
                                },
                                on: { parentCallBack: _vm.salesOfficeChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "销售部门",
                                required: "",
                                prop: "salesDept"
                              }
                            },
                            [
                              _c("cargo-department-select-by-office-id", {
                                attrs: {
                                  "office-id": Number(_vm.form.salesOffice),
                                  "department-id": Number(_vm.form.salesDept)
                                },
                                on: { change: _vm.salesDeptChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "销售", prop: "salesId" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  url: _vm.URL.order.getUsersByOfficeAndDept,
                                  cache: false,
                                  filterable: "",
                                  "default-value": _vm.form.salesId || "",
                                  "method-params": {
                                    officeId: _vm.form.salesOffice
                                      ? _vm.form.salesOffice
                                      : _vm.$store.getters.currentOfficeId,
                                    deptId: _vm.form.salesDept,
                                    category: "role",
                                    shape: "sales"
                                  },
                                  "tag-name": "chineseName",
                                  "tag-value": "userId"
                                },
                                on: { parentCallBack: _vm.salesChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "操作公司",
                                required: "",
                                prop: "opOffice"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Office,
                                  filterable: "",
                                  "default-value": _vm.form.opOffice,
                                  "tag-name": "chineseName"
                                },
                                on: { parentCallBack: _vm.opOfficeChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "操作部门",
                                required: "",
                                prop: "opDepartment"
                              }
                            },
                            [
                              _c("cargo-department-select-by-office-id", {
                                attrs: {
                                  "office-id": Number(_vm.form.opOffice),
                                  "department-id": Number(_vm.form.opDepartment)
                                },
                                on: { change: _vm.opDeptChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "操作", prop: "opId" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  url: _vm.URL.order.getUsersByOfficeAndDept,
                                  cache: false,
                                  filterable: "",
                                  "default-value": _vm.form.opId || "",
                                  "tag-name": "chineseName",
                                  "tag-value": "userId",
                                  "method-params": {
                                    officeId: _vm.form.opOffice
                                      ? _vm.form.opOffice
                                      : _vm.$store.getters.currentOfficeId,
                                    deptId: _vm.form.opDepartment,
                                    category: "role",
                                    shape: "op"
                                  }
                                },
                                on: { parentCallBack: _vm.opChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "操作要求",
                                prop: "operationRequirement"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.form.operationRequirement,
                                  placeholder: _vm.isLook
                                    ? ""
                                    : "双击添加操作要求",
                                  type: "textarea",
                                  rows: 2
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.selectOperationReqDialog.visible = true
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("select-operation-req-dialog", {
        attrs: {
          visible: _vm.selectOperationReqDialog.visible,
          lob: "SE",
          value: _vm.form.operationRequirement
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
          },
          callback: function(val) {
            return (_vm.form.operationRequirement = val)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }